import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_RECOVER_USERNAME } from "constants/apiUrls";

import getApiClient from "lib/apiClient/getApiClient";

type RecoverUsernameRequestBody = {
  email: string;
};

function useRequestRecoverUsername(): UseMutationResult<
  void,
  Error,
  RecoverUsernameRequestBody
> {
  const apiClient = getApiClient();

  return useMutation({
    mutationFn: async ({ email }) => {
      const response = await apiClient(API_RECOVER_USERNAME, {
        method: "POST",
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      }

      return Promise.resolve();
    },
  });
}

export default useRequestRecoverUsername;
